<template>

   <div v-bind:class="[adSearchStatus ? 'ad_search_wrap on' : 'ad_search_wrap']">
        <div class="ad_search_box">
            <div class="container popup_header">
                <h3>
                    Advanced Search
                </h3>
                <a href="#" class="ad_close_bt" @click="update">Close</a>
            </div>
        </div>
        <div class="ad_search_option">
            <div class="a_s_o_inner">

                <div class="ad_o_tbl">
                    <table class="write_tbl responsive_tbl">
                        <colgroup>
                        <col style="width:290px;">
                        <col style="">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>Search Keywords:</th>
                                <td><input type="text" v-model="searchWord" class="int_type01" title="Title" 
                                        placeholder="Enter keywords" 
                                        @keyup.enter="submitSearch"></td>
                            </tr>
                            <tr>
                                <th>{{$t("product.product")}}:</th>
                                <td>
                                    <div class="row">
                                        <div class="col-lg-6">
                                           <label class="option_i_label">Main Category</label>
                                          <select v-model="prod_class" @change="fetchMiddleProducts"  style="width:200px" class="int_type01">
                                               <option value="">Select Category</option>
                                               <option v-for="prod of mainProducts" v-bind:key="prod.id" v-bind:value="prod.id">{{prod.dispname}}</option>
                                          </select>  
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="option_i_label">Middle Category</label>
                                          <select v-model="prod_id" style="width:200px" class="int_type01">
                                               <option value="">Select Category</option>
                                               <option v-for="prod of middleProducts" v-bind:key="prod.id" v-bind:value="prod.id">{{prod.dispname}}</option>
                                          </select>   
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t("product.documentType")}}:</th>
                                <td>
                                    <ul class="ad_int_ul">
										<li><label><input type="checkbox" v-model="doctypes" id="om_checkbox" value="010000"><span>OM</span></label></li>
										<li><label><input type="checkbox" v-model="doctypes" id="sm_checkbox" value="020000"><span>SM</span></label></li>
									</ul>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t("product.cerfication")}}:</th>
                                <td>
                                    <select v-model="certification" style="width:200px" class="int_type01">
                                        <option value="">Select Certification</option>
                                        <option v-for="certi of certifications" v-bind:key="certi.id" v-bind:value="certi.id">{{certi.dispname}}</option>
                                    </select> 
                                </td>
                            </tr>

                            <tr v-if="totalSearch">
                                <th>Publication Type:</th>
                                <td>
                                    <ul class="ad_int_ul">
										<li><label><input type="checkbox" v-model="pubtypes" id="html_checkbox" value="html"><span>WebHelp</span></label></li>
										<li><label><input type="checkbox" v-model="pubtypes" id="pdf_checkbox" value="pdf"><span>PDF</span></label></li>
									</ul>
                                </td>
                            </tr>
                            <tr>
                                <th>Published Date:</th>
                                <td>
                                    <div class="row gx-md-5 ad_date_row">
                                        <div class="col-lg-6">
                                            <date-picker v-model="pubdate1" type="date" ></date-picker> 
                                        </div>
                                        <div class="col-lg-6" style="padding-left:35px;">
                                            <date-picker v-model="pubdate2" type="date" ></date-picker>  
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        
                        </tbody>
                    </table>
                    <div class="ad_search_bottom">
                        <button class="btn btn-primary btn-lg" @click="submitSearch">Search</button>
                    </div>
                </div>
             </div>
        </div>
    </div>
</template>

<script>
import { getMainSearchCodes, getMiddleProducts} from '@/api/search';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components: { DatePicker },
    props : ["adSearchStatus","totalSearch"],
    data() {
        return {
            searchWord: '',
            prod_class: '',
            prod_id: '',
            doc_type: '',
            pub_type: '',
            certification : '',
            pubdate1: '',
            pubdate2: '',
            mainProducts: [],
            middleProducts: [],
            certifications: [],
            doctypes: [],
            pubtypes: []
        }
    },
    methods : {
        async fetchMainCodes(){  
            try {
                const response = await getMainSearchCodes(this.form);
                const data = response.data; 
                
                this.mainProducts = data.prod;
                this.certifications = data.certi;

            } catch (error) {
                console.log(error);
            }
        },
        async fetchMiddleProducts(){  
            try {
                console.info(this.prod_class);
                const response = await getMiddleProducts(this.prod_class);
                this.middleProducts = response.data;
                console.info(this.middleProducts);
            } catch (error) {
                console.log(error);
            }
        },
        update() {
                this.$emit("update", !this.adSearchStatus);
        },
        submitSearch() {
            const payload = {
                searchWord: this.searchWord,
                prod_class: this.prod_class,
                prod_id: this.prod_id,
                doc_type: this.doctypes,
                pub_type: this.pubtypes,
                certification : this.certification,
                pubdate1: this.pubdate1,
                pubdate2: this.pubdate2
            };
            this.$emit("clickSearch", payload);
            this.$emit("update", !this.adSearchStatus);
        }
    },
    created(){
        this.fetchMainCodes();
    }
}

</script>

<style scoped>

</style>